import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AdminSidebar } from '@shared/components/admin-sidebar/admin-sidebar';
import { AdminHeader } from '@shared/components/admin-header/admin-header';

@Component({
  selector: 'app-bo-layout',
  imports: [RouterOutlet, AdminSidebar, AdminHeader],
  templateUrl: './bo-layout.html',
  styleUrl: './bo-layout.scss',
})
export class BoLayout {}
